export const EXPERTISE_LIST = [
    "Beginner level",
    "Intermediate level",
    "Qualified level",
];

export const LANGUAGE_LIST = [
    "English",
    "Kiswahili",
    "Français",
    "Português",
    "Afrikaans",
    "IsiZulu",
    "Isixhosa",
];

export const COUNTRY_LIST = [
    "Botswana",
    "Ghana",
    "Kenya",
    "Namibia",
    "Nigeria",
    "Rwanda",
    "South Africa",
    "Tanzania",
    "Uganda",
    "Zambia",
    "Zimbabwe",
];

export const INFORMATION_TYPE_LIST = [
    "Job post",
    "Aid information",
];

export const SIDE_MENU = [
    { label: 'Dashboard', routeName: 'dashboard' },
    { label: 'Signer', routeName: 'interpreters' },
    { label: 'Guides', routeName: 'guides' },
    { label: 'Post Management', routeName: 'postManagement' },
    { label: 'Contact Management', routeName: 'contactManagement' },
    { label: 'Entity Category', routeName: 'entityCategories' },
    { label: 'Entities', routeName: 'entityManagement' },
    { label: 'Content', routeName: 'content' },
    { label: 'Events', routeName: 'events' },
    { label: 'Help Center', routeName: 'help-center' },
    // {
    //     label: 'Phonebook Entities',
    //     routeName: 'phoneBook',
    //     submenu: [
    //       { label: 'Category', routeName: 'entityCategories' },
    //       { label: 'Entity', routeName: 'entityManagement' },
    //     ],
    //   },
];

export const ENTITY_ADMIN_SIDE_MENU = [
    { label: 'Dashboard', routeName: 'dashboard' },
    { label: 'Entity Management', routeName: 'entityDetail/:id/basicDetails' },
    { label: 'Content', routeName: 'content' },
    { label: 'Events', routeName: 'events' },
    { label: 'Workspace', routeName: 'workspace' },
    { label: 'Help Center', routeName: 'help-center' }
];

export const SIGN_INTERPRETER_SIDE_MENU = [
    { label: 'Content', routeName: 'content' },
    { label: 'Events', routeName: 'events' },
    { label: 'Workspace', routeName: 'workspace' },
    { label: 'Help Center', routeName: 'help-center' },
];

export const ENTITY_STAFF_SIDE_MENU = [
    { label: 'Content', routeName: 'content' },
    { label: 'Events', routeName: 'events' },
    { label: 'Workspace', routeName: 'workspace' },
    { label: 'Help Center', routeName: 'help-center' }
];

export const ROLES = {
    "SUPER_ADMIN": "Super Admin",
    "SIGN_INTERPRETER": "Sign Interpreter",
    "ENTITY_ADMIN": "Entity Admin",
    "ENTITY_STAFF": "Entity Staff",
    "USER": "User",
    "ENTITY_USER": "Entity User",
    "GUIDE": "Guide",
}

export const EVENT_TYPES = [
  { id: 1, value: 'webinar', label: 'Webinar' },
  { id: 2, value: 'training', label: 'Training' },
  { id: 3, value: 'panel', label: 'Panel Discussion' },
  { id: 4, value: 'other', label: 'Other' },
];